// extracted by mini-css-extract-plugin
export default {"container":"container__SXeaU","checkbox":"checkbox__EJECe"};